module.exports = __webpack_public_path__ + "assets/img/img59.7899d9bb.png";